export const PAYPAL_TEST_ID = 'paypal.button';
